import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { LanguageListComponent } from './language-list/language-list.component';

@NgModule({
  declarations: [
    LanguageSelectorComponent,
    LanguageListComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  exports: [
    LanguageSelectorComponent,
    LanguageListComponent
  ]
})
export class LanguageModule { }
